<template>
  <router-view />
</template>
<script>
export default {
  name: 'App',
  date() {
    return {
    }
  },
  mounted() {
    // this.checkSocket()
  },
  methods: {
  },
  watch: {

  },
}
</script>
<style lang="scss">
::-webkit-scrollbar {
  width: 2px;
}

::-webkit-scrollbar-thumb {
  /* remove scrollbar space */
  background-color: var(--v-primary-base);
  border-radius: 10px;
  /* optional: just make scrollbar invisible */
}
</style>
